import { render, staticRenderFns } from "./BatchSamples.vue?vue&type=template&id=35d9f51e&scoped=true"
import script from "./BatchSamples.vue?vue&type=script&lang=js"
export * from "./BatchSamples.vue?vue&type=script&lang=js"
import style0 from "./BatchSamples.vue?vue&type=style&index=0&id=35d9f51e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d9f51e",
  null
  
)

export default component.exports